/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { sendSubscriptionFormPostRequestSchema } from './sendSubscriptionFormPostRequestSchema.ts';
import { sendSubscriptionFormPostResponseSchema } from './sendSubscriptionFormPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postSendSubscriptionForm200Schema = z.lazy(() => sendSubscriptionFormPostResponseSchema);

/**
 * @description 505 response
 */
export const postSendSubscriptionForm505Schema = z.any();

export const postSendSubscriptionFormMutationRequestSchema = z.lazy(() => sendSubscriptionFormPostRequestSchema);

export const postSendSubscriptionFormMutationResponseSchema = z.lazy(() => postSendSubscriptionForm200Schema);
